<template>
    <div class="reports-payment">
        <div class="reports-payment__top">
            <div class="reports-payment__select">
                <v-text-field
                    v-model="requestData.from"
                    dense
                    outlined
                    type="date"
                    name="from"
                    :label="textContent['from']"
                    hide-details
                ></v-text-field>
            </div>
            <div class="reports-payment__select">
                <v-text-field
                    v-model="requestData.to"
                    dense
                    outlined
                    type="date"
                    name="to"
                    :label="textContent['to']"
                    hide-details
                ></v-text-field>
            </div>
            <v-btn
                class="reports-payment__btn"
                dark
                color="#967adc"
                :loading="isTableLoading"
                @click="dateEmployeesHandle"
            >
                {{ $t('pages.report.reload') }}
            </v-btn>
            <v-btn
                class="reports-payment__btn-pdf"
                outlined
                dark
                color="#967adc"
                :loading="isPdfLoading"
                @click="generatePdf"
                >pdf
            </v-btn>
        </div>

        <template>
            <ReportsUsersTable
                @filters-change="updateFilters"
                @sort-change="updateSort"
            />
        </template>

        <v-pagination
            v-if="pagination && pagination.lastPage > 1"
            v-model="page"
            :total-visible="7"
            :length="pagination.lastPage"
            color="#3bafda"
            class="pagination"
            @input="onPageChange"
        ></v-pagination>
    </div>
</template>

<script>
import languageMixin from '@/mixins/language.mixin'
import languageOrderExtraMixin from '@/mixins/language-order-extra.mixin'
import { mapActions, mapGetters } from 'vuex'
import { actionTypes, getterTypes } from '@/store/modules/report'
import regularToSnakeCase from '@/helpers/regular-to-snake-case'
import ReportsUsersTable from '@/components/reports/reports-users-table'
import { buildDateParams } from '@/helpers/build-date-params.utils'

export default {
    name: 'ReportsUsers',
    components: { ReportsUsersTable },
    mixins: [languageMixin, languageOrderExtraMixin],
    data: () => ({
        employees: false,
        requestData: {
            from: '',
            to: '',
        },

        localFilters: {
            client: [],
            employee: [],
            status: [],
        },

        appliedFilters: {
            client: [],
            employee: [],
            status: [],
        },

        page: 1,
        perPage: 20,

        sort: [],

        isTableLoading: false,
        isPdfLoading: false,
    }),
    computed: {
        ...mapGetters('report', {
            getAllEmployees: getterTypes.getAllEmployees,
        }),
        pagination: function () {
            return this.getAllEmployees.pagination ?? null
        },
    },
    mounted() {
        this.presentDate()
        // this.dateEmployeesHandle()
    },
    methods: {
        ...mapActions('report', {
            getEmployees: actionTypes.getEmployees,
            getEmployeesPdf: actionTypes.getEmployeesByPdf,
        }),
        addZero: function (data) {
            return data < 10 ? '0' + data : data
        },
        presentDate: function () {
            const date = new Date()
            const year = date.getFullYear()
            const month = this.addZero(date.getMonth() + 1)
            const day = this.addZero(date.getDate())

            this.requestData.from = `${year}-${month}-${day}`
            this.requestData.to = `${year}-${month}-${day}`
        },
        getStatus: function (status) {
            return this.extraContent[regularToSnakeCase(status)]
        },
        dateEmployeesHandle: async function () {
            if (this.isTableLoading) return

            this.appliedFilters = { ...this.localFilters }
            this.page = 1
            this.fetchEmployees()
        },
        updateFilters: function (filters) {
            this.localFilters = filters
        },
        onPageChange: function (page) {
            this.page = page
            this.fetchEmployees()
        },
        updateSort: function (value) {
            this.sort = value
            this.page = 1
            this.fetchEmployees()
        },
        fetchEmployees: async function () {
            try {
                this.isTableLoading = true
                const dates = buildDateParams(
                    this.requestData.from,
                    this.requestData.to
                )

                await this.getEmployees({
                    ...dates,
                    client_id: this.appliedFilters.client,
                    employee_id: this.appliedFilters.employee,
                    status: this.appliedFilters.status,
                    page: this.page,
                    per_page: this.perPage,
                    sort: this.sort,
                })
            } finally {
                this.isTableLoading = false
            }
        },
        generatePdf: async function () {
            if (this.isPdfLoading) return

            this.isPdfLoading = true

            const payload = {
                from: `${this.requestData.from} 00:00:00`,
                to: `${this.requestData.to} 23:59:59`,
                client_id: this.appliedFilters.client,
                status: this.appliedFilters.status,
                employee_id: this.appliedFilters.employee,
                sort: this.sort,
                format: 'pdf',
            }

            try {
                const response = await this.getEmployeesPdf(payload)

                const fileUrl = response?.url
                if (!fileUrl) {
                    console.error('No PDF URL in response')
                    return
                }

                window.open(fileUrl, '_blank')
            } catch (e) {
                console.error('PDF download error:', e)
            } finally {
                this.isPdfLoading = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.reports-payment {
    &__top {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 16px;
    }

    &__switch {
        display: flex;
        align-items: center;
    }

    &__text {
        margin-right: 7px;
        font-size: 16px;

        @include for-hebrew {
            margin-right: 0;
            margin-left: 7px;
        }
    }

    &__select {
        height: 57px;
        max-width: 200px;
        width: 100%;

        & + & {
            margin: 0 10px;
        }
    }

    &__name {
        color: #939393;
    }

    &__btn {
        max-width: 130px;
        height: 40px;
    }

    &__btn-pdf {
        margin-left: 15px;

        @include for-hebrew {
            margin-left: 0;
            margin-right: 15px;
        }
    }

    td {
        text-transform: capitalize;
    }
}
</style>
